<script>
import { Event } from '@/plugins/bus';

export default {
  methods: {
    async getAnnouncement(id) {
      try {
        this.$wait.start('loading announcement');
        const response = await this.$api.get(`announcements/${id}`);
        return response.data;
      } catch (err) {
        if (err.response.status == 404) {
          return null;
        }
        this.$toast.error('There was an error getting announcement');
        return null;
      } finally {
        this.$wait.end('loading announcement');
      }
    },
    async addAnnouncement(update) {
      try {
        this.$wait.start('add announcement');
        const response = await this.$api.post(`announcements`, update);
        this.$bus.$emit(Event.AnnouncementUpdated, { id: update.id });
        this.$toast.success(`Announcement added`);
        return response;
      } catch (err) {
        this.$toast.error(`Could not add Announcement`);
        return null;
      } finally {
        this.$wait.end('add announcement');
      }
    },
    async updateAnnouncement(update) {
      try {
        this.$wait.start('loading announcement');
        const response = await this.$api.put(`announcements/${update.id}`, update);
        this.$toast.success(`Announcement updated`);
        return response;
      } catch (err) {
        this.$toast.error(`Could not update Announcement`);
        return null;
      } finally {
        this.$wait.end('loading announcement');
      }
    },
    async getAnnouncements() {
      try {
        this.$wait.start('loading announcement');
        const response = await this.$api.get(`announcements?orderBy=createdOn&orderByDescending=true`);
        return response.data;
      } catch (err) {
        this.$toast.error(`Could not get announcements`);
        return null;
      } finally {
        this.$wait.end('loading announcement');
      }
    },
    async getUnseenAnnouncements(page, pageSize) {
      try {
        page = page || 1;
        pageSize = pageSize || 10;
        this.$wait.start('loading unseen announcement');
        const response = await this.$api.get(`announcements/unseen?orderBy=publishedOn&orderByDescending=true&page=${page}&pageSize=${pageSize}`);
        return response.data;
      } catch (err) {
        this.$toast.error(`Could not get unseen announcements`);
        return null;
      } finally {
        this.$wait.end('loading unseen announcement');
      }
    },
    async getUserAnnouncements(page, pageSize) {
      try {
        page = page || 1;
        pageSize = pageSize || 10;
        this.$wait.start('loading user announcements');
        const response = await this.$api.get(`announcements/by-user?orderBy=publishedOn&orderByDescending=true&page=${page}&pageSize=${pageSize}`);
        return response.data;
      } catch (err) {
        this.$toast.error(`Could not get user announcements`);
        return null;
      } finally {
        this.$wait.end('loading user announcements');
      }
    },
    async markAnnouncementAsPublished(id) {
      try {
        this.$wait.start('publishing announcement');
        await this.$api.post(`announcements/mark-as-published`, [id]);
        this.$bus.$emit(Event.AnnouncementUpdated, { id });
        this.$toast.success(`Announcement published`);
        return true;
      } catch (err) {
        this.$toast.error(`Could not publish announcement`);
        return false;
      } finally {
        this.$wait.end('publishing announcement');
      }
    },
    async markAnnouncementAsSeen(id) {
      try {
        this.$wait.start('acknowledge announcement');
        await this.$api.post(`announcements/mark-as-seen`, [id]);
        this.$bus.$emit(Event.AnnouncementUpdated, { id });
        this.$toast.success(`Announcement Marked as Seen`);
        return true;
      } catch (err) {
        this.$toast.error(`Could not mark announcement as seen`);
        return false;
      } finally {
        this.$wait.end('acknowledge announcement');
      }
    },
    async deleteAnnouncement(id) {
      try {
        this.$wait.start('deleting announcement');
        await this.$api.delete(`announcements/${id}`);
        this.$toast.success(`Announcement deleted`);
        return true;
      } catch (err) {
        this.$toast.error(`Could not delete announcement`);
        return false;
      } finally {
        this.$wait.end('deleting announcement');
      }
    }
  }
};
</script>
